import { useTheme, ContentDirection, } from '@workday/canvas-kit-react/common';
export const useRTL = (partialTheme) => {
    const theme = useTheme(partialTheme);
    const shouldUseRTL = theme.canvas.direction === ContentDirection.RTL;
    return {
        shouldUseRTL,
    };
};
